import $ from "jquery";
import Foundation from "./3rd/_zf.js";
//import { hdConfig } from './components/config.js';

import "./components/global.js";
import "./components/lighthouse.js";
import "./components/back-to-top.js";
import "./components/script-loader.js";
import "./components/recruitment-search.js";
import "./components/shareholders.js";
import "./components/footer-accordion.js";
import { initMenu } from "./components/menu.js";
import { initSocialShare } from "./components/social-share.js";
//import SimpleBar from 'simplebar';
//import ResizeObserver from 'resize-observer-polyfill';
import { Fancybox } from "@fancyapps/ui";
//import select2 from 'select2';

//window.ResizeObserver = ResizeObserver;
//select2();

// Styles
import "../sass/3rd/_index.scss";
//import 'simplebar/dist/simplebar.css';
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  initMenu("nav.nav", ".main-nav");
  initSocialShare("[data-social-share]", {
    intents: ["facebook", "x", "print", "send-email", "copy-link", "web-share"],
  });
});

Fancybox.bind(".fcy-popup, .fcy-video, .banner-video a", {});
Fancybox.bind(
  '.wp-block-gallery .wp-block-image a, [id^="gallery-"] a, [data-rel="lightbox"]',
  {
    groupAll: true, // Group all items
  },
);

jQuery(function ($) {
  const BREAKPOINT = 1024; // lg
  const $bottomHeader = $("#bottom-header");
  const $insideHeader = $("#inside-header");

  let ticking = false;
  let lastScroll = 0;
  let $activeHeader = null;
  let activeHeight = 0;

  function getActiveHeader() {
    return window.innerWidth >= BREAKPOINT ? $bottomHeader : $insideHeader;
  }

  function updateActiveHeader() {
    // Remove sticky from both when switching
    $bottomHeader.removeClass("w-sticky");
    $insideHeader.removeClass("w-sticky");

    $activeHeader = getActiveHeader();
    if (!$activeHeader.length) {
      $activeHeader = null;
      return;
    }
    activeHeight = $activeHeader.outerHeight(true) || 0;
  }

  function updateSticky() {
    if (!$activeHeader) return;
    if (lastScroll > activeHeight + 80) {
      $activeHeader.addClass("w-sticky");
    } else {
      $activeHeader.removeClass("w-sticky");
    }
    ticking = false;
  }

  // Init
  updateActiveHeader();

  // Scroll
  $(window).on("scroll.stickyHeader", function () {
    lastScroll = $(this).scrollTop();
    if (!ticking) {
      requestAnimationFrame(updateSticky);
      ticking = true;
    }
  });

  // Resize — swap target on breakpoint cross
  $(window).on("resize.stickyHeader", function () {
    updateActiveHeader();
    updateSticky();
  });
});

// them read-more cho mo ta danh muc
jQuery(document).ready(function () {
  jQuery(".term-tax-custom .term-description").each(function () {
    if (jQuery(this).height() > 300) {
      jQuery(this).after(
        '<a href="#" class="btn_show btn-main bg-white">Xem thêm</a><div class="mask"></div>',
      );
      jQuery(this).attr("data-height", jQuery(this).height() + "px");
      jQuery(this).css({
        height: "300",
      });
    }
  });
  jQuery(".btn_show").click(function (e) {
    e.preventDefault();
    var this_content = jQuery(this)
      .closest(".term-tax-custom")
      .find(".term-description");
    jQuery(this).closest(".term-tax-custom").find(".mask").remove();
    jQuery(this_content).animate(
      {
        height: jQuery(this_content).attr("data-height"),
      },
      500,
    );
    jQuery(this).remove();
  });
});
// Counter Animation
$(document).ready(function () {
  function animateCounter($el, target) {
    $({ countNum: 0 }).animate(
      { countNum: target },
      {
        duration: 2000,
        easing: "swing",
        step: function () {
          $el.text(Math.floor(this.countNum).toLocaleString("de-DE"));
        },
        complete: function () {
          $el.text(this.countNum.toLocaleString("de-DE"));
        },
      },
    );
  }
  function startCounters() {
    $(".counter").each(function () {
      var $this = $(this);
      var target = parseInt($this.data("target"));
      if (
        !$this.hasClass("counted") &&
        $(window).scrollTop() + $(window).height() > $this.offset().top
      ) {
        animateCounter($this, target);
        $this.addClass("counted");
      }
    });
  }
  $(window).on("scroll", startCounters);
  startCounters();
});

jQuery(function ($) {
  const $btn = $("#toggle-contact");
  const $list = $("#contact-links");
  // init trạng thái ban đầu
  const initiallyVisible = $list.is(":visible");
  $btn.toggleClass("is-open", initiallyVisible);
  $btn.attr("aria-expanded", initiallyVisible);
  $btn.find(".icon-default").toggle(!initiallyVisible);
  $btn.find(".icon-close").toggle(initiallyVisible);
  $btn.on("click", function (e) {
    e.preventDefault();
    // tính trạng thái sắp tới
    const willOpen = !$btn.hasClass("is-open");
    // đổi class + aria ngay (icon thay đổi ngay lập tức)
    $btn.toggleClass("is-open", willOpen);
    $btn.attr("aria-expanded", willOpen);
    $btn.find(".icon-default").toggle(!willOpen);
    $btn.find(".icon-close").toggle(willOpen);
    // chạy animation (không cần dựa vào :visible ngay lúc này)
    $list.stop(true, false).slideToggle(200);
  });
});

//
// TAB PRODUCT CAT - HOME
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".pt-tabs-nav .pt-tab");
  const panels = document.querySelectorAll(".pt-tab-panel");
  if (!tabs.length) return;
  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const id = this.dataset.tab;
      tabs.forEach((t) => t.classList.remove("active"));
      panels.forEach((p) => p.classList.remove("active"));
      this.classList.add("active");
      const panel = document.getElementById(id);
      if (panel) panel.classList.add("active");
    });
  });
});
